import React, { Component } from 'react';
import $, { isArray } from 'jquery';
import SweetAlert from 'sweetalert-react';
import bookmark_white from '../img/bookmark_white.png';
import * as requestLib from '../lib/requestLib';
import { dummyData_article, dummyData_Behavior, dummyData_Compounds } from '../dummy';
import GroupView from '../components/Group/GroupView';
import AddGroupView from '../components/Group/AddGroupView';
import BookLoading from "./BookLoading";
import Loading from './Loading';
import { replaceThumbnails } from '../thumbnail';
var chemicalFormula = require('chemical-formula');

export default class ResultDetail extends Component {
	constructor(props) {
		super(props);

		this.state = {
			Scientific_name: '',
			Common_name: '',
			Paper_contents: [],
			Paper_behavior: dummyData_Behavior,
			Paper_compounds: [],
			isLoaded: false,
			// Paper_list: this.props.Paper_list,
			Paper_list: '54305, 54288',
			// BS_id: this.props.BS_id,
			BS_id: '201994_2170',
			comment: '',
			selectGroup: '1',
			addGroupAlert: false,
			modGroupAlert: false,
			queryString: '',
			groupList: [],
			tab: 'article',
			selectValue: 0,
			groupViewState: false,
			addGroupView: false,
			data: null,
			bookLoading: false,
			scrapAllId: '',
			invalid: false,
			compound_ids: 'invalid',
			pending: false
		};

		this.baseUrl = requestLib.getUrl();
	}

	groupViewShow(boolean) {
		this.setState({
			isShowGroupView: boolean,
		});
	}

	createNewGroup(boolean) {
		this.setState({ addGroupView: boolean });
	}

	getCookie(name) {
		let value = '; ' + document.cookie;
		let parts = value.split('; ' + name + '=');
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	componentDidMount() {
		window.addEventListener('click', (e) => {
			if (e.target.className !== 'scrap' && e.target.className !== 'scrap-all') {
				this.setState({ groupViewState: false })
			}
		})
	}

	componentWillMount() {
		let accessToken = this.getCookie('accessToken');
		// let accessToken = "183a8834ecdbb8148d6fb5daa0a688933a67dd6c9607ed1669d1765f88de7cf1";

		let url = window.location.href;
		if (url.indexOf('localhost') !== -1) {
			// accessToken = 'b6290c857f16017027645a9e6e3528a3a48d0705f026b4c4e40b54e7d4446790';
		}

		$.ajax({
			url: this.baseUrl + 'api/Group/getGroupList',
			data: { userToken: accessToken },
			method: 'get',
			dataType: 'json',
			success: function (response) {
				this.setState({
					groupList: response.data,
					accessToken: accessToken,
				});
				this.props.groupUpdate(response.data);
			}.bind(this),
			error: function (e) { }.bind(this),
		});

		url = url.split('?s=');
		url = url[1];

		this.setState({ queryString: url });
	}

	compoundData = (compoundIds) => {
		if (compoundIds == 'Invalid') {
			this.setState({ invalid: true, bookLoading: false });
		} else {
			const data = {
				data: compoundIds
			}
			$.ajax({
				url: 'https://tply87eoej.execute-api.us-west-1.amazonaws.com/prod/search',
				data: JSON.stringify(data),
				method: 'post',
				contentType: 'application/json',
				dataType: 'json',
				timeout: 30000,
				success: function (response) {
					if (response) {
						this.setState({ Paper_compounds: response.body, bookLoading: false, invalid: false });
					}

				}.bind(this),
				error: function (e) { if (e) { this.setState({ bookLoading: false, invalid: true, pending: true, tab: 'article' }) } }.bind(this),
			});
		}
	};

	changePapers(taxa_id) {
		let articles, sname, cname, img, data, domain, compound_ids;

		this.setState({ isLoaded: false });

		this.props.articles.map((v) => {
			if (v.taxa_id == taxa_id) {
				articles = v.articles;
				sname = v.sname;
				cname = v.cname;
				domain = v.domain;
				img = v.img;
				data = v
				compound_ids = v.compound_ids;
			}
		});

		if (compound_ids == 'Invalid') {
			this.setState({ invalid: true });
		} else {
			this.setState({ invalid: false });
		}

		this.setState({
			Scientific_name: sname,
			Common_name: cname,
			Paper_contents: articles,
			img,
			domain,
			isLoaded: true,
			data,
			compound_ids,
			bookLoading: false
		});
	}

	clickCloseArticle() {
		this.setState({
			isLoaded: false,
			selectValue: 0,
			tab: 'article',
			groupViewState: false,
			bookLoading: true,
			pending: false
		});
		this.props.clickCloseArticle();
		this.props.endloaded();
	}

	clickHandle(e) {
		let className = e.currentTarget.className;
		let selectValue = this.state.selectValue;
		let select = document.querySelector('.select');

		if (className == 'left') {
			selectValue = selectValue - 1;
		} else {
			selectValue = selectValue + 1;
		}

		select.value = selectValue;
		this.setState({ selectValue });
	}

	bookMarkHandle(r) {
		let accessToken = this.getCookie('accessToken');
		let tab = this.state.tab;


		let id;
		if (tab == 'compounds') {
			id = r.Compound_id;
		} else {
			id = r.id
		}
		if (this.state.groupViewState == id) {
			id = false;
		}

		this.setState({ groupViewState: id })
		if (id) {
			$.ajax({
				url: this.baseUrl + 'api/Group/getGroupList',
				data: { userToken: accessToken, identity: id },
				method: 'get',
				dataType: 'json',
				success: function (response) {
					this.setState({
						groupList: response.data,
						accessToken: accessToken,
					});



				}.bind(this),
				error: function (e) { console.log(e) }.bind(this),
			});
		}
	}

	scrapAll(e) {
		let target = e.currentTarget.className;
		let ids = [];
		let accessToken = this.getCookie('accessToken');

		if (this.state.groupViewState == 'scrap-all') {
			target = false;
		}

		if (target) {
			this.state.data.articles.map(v => {
				ids.push(parseInt(v.id))
			});

			$.ajax({
				url: this.baseUrl + 'api/Group/getGroupList',
				data: { userToken: accessToken, type: 'organism', identity: JSON.stringify(ids) },
				method: 'get',
				dataType: 'json',
				success: function (response) {
					this.setState({
						groupList: response.data,
					});

				}.bind(this),
				error: function (e) { console.log(e) }.bind(this),
			});
		};

		this.setState({ groupViewState: target, scrapAllId: JSON.stringify(ids) })
	}


	infoRender() {
		let tab = this.state.tab;

		if (Array.isArray(this.state.Paper_contents)) {
			if (tab == 'article') {
				return this.state.Paper_contents.map((r) => {

					return (
						<div className="article-wrap">
							<article key={r.paper_id}>
								<div className="name-wrap">
									<h6>Scientific Name</h6>
									<h3>{this.state.Scientific_name}</h3>
								</div>
								<div className="name-wrap">
									<h6>Common Name</h6>
									<h2 id="common">
										<span>{this.state.Common_name}</span>
									</h2>
								</div>
								<div className="name-wrap">
									<h6>Title of thesis</h6>
									<h3>{r.title}</h3>
								</div>
								<div className="name-wrap">
									<h6>Published in</h6>
									<h4>{r.journal_title}</h4>
								</div>
								<div className="name-wrap">
									<h6>Published by</h6>
									<h4>{r.authors}</h4>
								</div>
								<div className="c50">
									<h6>Publication Date</h6>
									<h3>{r.year}</h3>
								</div>
								<p>{r.summary}</p>
								<div className="btn-wrap">
									{r.link_url !== 'Unknown' && (
										<a target="_blank" href={r.link_url}>
											Read more
										</a>
									)}
									<button onClick={() => this.bookMarkHandle(r)} className="scrap">
										Scrap
									</button>
									{this.state.groupViewState == r.id && (
										<GroupView
											createNewGroup={(boolean) => this.createNewGroup(boolean)}
											token={this.state.accessToken}
											groupList={this.state.groupList}
											type={this.state.tab}
											id={r.id}
											data={r}
											sname={this.state.Scientific_name}
											cname={this.state.Common_name}
											img={this.state.img}
											showToast={(num) => this.props.showToast(num)}
											alreadySavedAlert={() => this.setState({ already: true })}
											setGroupViewState={() => this.setState({ groupViewState: false })}
										/>
									)}
								</div>
							</article>
						</div>
					);
				});
			} else if (tab != 'article') {
				let list;
				let ogList;
				let selectValue = Number(this.state.selectValue);

				if (!this.state.bookLoading && !this.state.pending) {
					if (tab == 'behavior') {
						list = this.state.Paper_behavior;
						ogList = null;
					} else if (tab == 'compounds') {
						list = this.state.Paper_compounds;
						ogList = this.state.Paper_compounds;
					}

					let isArray = Array.isArray(ogList);

					if (isArray) list = list[selectValue];

					let formula = chemicalFormula(list['Mformula'])

					let mFormula = [];

					Object.keys(formula).map(v => {
						mFormula.push({ key: v, sub: formula[v] })
					})

					return (
						<div className="article-wrap">
							{isArray ? (
								<form className="select-wrap">
									<select className="select" onChange={(e) => this.setState({ selectValue: e.currentTarget.value })}>
										{ogList.map((v, i) => {
											return <option value={i}>{v.Name}</option>;
										})}
									</select>
									<i className="fas fa-chevron-down"></i>
									<p>
										<span>{ogList.length - 1}</span> others
									</p>
								</form>
							) : null}
							<article className={isArray ? 'compounds' : ''}>
								{isArray && <div className="name-wrap compound modula">
									<h6>
										{mFormula.map(v => {
											return <React.Fragment>{v.key}<sub>{v.sub}</sub></React.Fragment>
										})}
									</h6>
								</div>}
								{Object.keys(list).map((r) => {
									let key = r.replaceAll('_', ' ');

									return key == 'Image' ? (
										<div className={isArray ? 'name-wrap compound' : 'name-wrap behavior'}>
											<img src={list[r]} />
										</div>
									) : (
										r !== 'Compound_id' && <div className={isArray ? 'name-wrap compound' : 'name-wrap behavior'}>
											<h6>{key}</h6>
											<h3>{list[r]}</h3>
										</div>
									);
								})}
								<div className="btn-wrap">
									<button onClick={() => this.bookMarkHandle(list)} className="scrap">
										Scrap
									</button>
								</div>
								{this.state.groupViewState == list.Compound_id && (
									<GroupView
										token={this.state.accessToken}
										createNewGroup={(boolean) => this.createNewGroup(boolean)}
										groupList={this.state.groupList}
										type={this.state.tab}
										id={list.Compound_id}
										data={list}
										img={this.state.img}
										showToast={(num) => this.props.showToast(num)}
										alreadySavedAlert={() => this.setState({ already: true })}
										setGroupViewState={() => this.setState({ groupViewState: false })}
									/>
								)}

							</article>
							{isArray ? (
								<div className="article-btn-wrap">
									{selectValue > 0 && (
										<button className="left" onClick={(e) => this.clickHandle(e)}>
											<i className="fas fa-chevron-left"></i>
											<span>{ogList[selectValue - 1].Name}</span>
										</button>
									)}
									{ogList.length - 1 > selectValue && (
										<button className="right" onClick={(e) => this.clickHandle(e)}>
											<span>{ogList[selectValue + 1].Name}</span>
											<i className="fas fa-chevron-right"></i>
										</button>
									)}
								</div>
							) : null}
						</div>
					);

				}
			}
		}

		let option = [];
		if (this.state.groupList && this.state.groupList.length !== 0) {
			option = this.state.groupList.map((v, k) => {
				return <option value={v.groupId}>{v.title}</option>;
			});
		}
	}

	infoHandle() {
		let queryString = this.state.queryString;
		let keywordArr = [];
		if (queryString) {
			keywordArr = queryString.split('%20');
		}
		return this.infoRender();
	}

	compoundsTabHandle = () => {
		this.setState({ bookLoading: true });
		this.setState({ tab: 'compounds' });
		this.compoundData(this.state.compound_ids)

	}

	replaceImg = () => {
        return replaceThumbnails[this.state.domain];
    };

	render() {
		return (
            <article
                className={
                    this.state.isLoaded === true
                        ? 'docViewer active'
                        : 'docViewer'
                }
            >
                <div
                    className="detail-thumb"
                    style={{
                        backgroundImage: `url(${
                            this.state.img
                        }), url(${this.replaceImg()})`,
                    }}
                >
                    <div
                        className="thumb"
                        style={{
                            backgroundImage: `url(${
                                this.state.img
                            }), url(${this.replaceImg()})`,
                        }}
                    ></div>
                    <button
                        className="docClose"
                        onClick={() => this.clickCloseArticle()}
                        style={{
                            display:
                                this.state.isLoaded === true
                                    ? 'inline-block'
                                    : 'none',
                        }}
                    >
                        <i className="fas fa-arrow-left"></i>
                    </button>
                </div>
                <div className="detail-info">
                    <ul className="detail-tab">
                        <li
                            className={
                                this.state.tab == 'article' ? 'tab-active' : ''
                            }
                        >
                            <button
                                onClick={() =>
                                    this.setState({ tab: 'article' })
                                }
                            >
                                Articles
                            </button>
                        </li>
                        {/* <li className={this.state.tab == 1 ? 'tab-active' : ''}>
							<button onClick={() => this.setState({ tab: 1 })}>Behavior</button>
					</li> */}
                        {!this.state.invalid && (
                            <li
                                className={
                                    this.state.tab == 'compounds'
                                        ? 'tab-active'
                                        : ''
                                }
                            >
                                <button
                                    onClick={() => this.compoundsTabHandle()}
                                >
                                    Compounds
                                </button>
                            </li>
                        )}

                        <button
                            className="scrap-all"
                            onClick={(e) => this.scrapAll(e)}
                        >
                            Scrap All
                        </button>
                        {this.state.groupViewState == 'scrap-all' && (
                            <GroupView
                                token={this.state.accessToken}
                                createNewGroup={(boolean) =>
                                    this.createNewGroup(boolean)
                                }
                                groupList={this.state.groupList}
                                type={'organism'}
                                domain={this.state.domain}
                                id={this.state.scrapAllId}
                                data={this.state.data}
                                img={this.state.img}
                                showToast={(num) => this.props.showToast(num)}
                                setGroupViewState={() =>
                                    this.setState({ groupViewState: false })
                                }
                            />
                        )}
                    </ul>
                    <SweetAlert
                        show={this.state.loadingAlert}
                        title="Now loading."
                        text=""
                        onConfirm={() => this.setState({ loadingAlert: false })}
                    />
                    <SweetAlert
                        show={this.state.emptySelectGroup}
                        title="Select group."
                        text=""
                        onConfirm={() =>
                            this.setState({ emptySelectGroup: false })
                        }
                    />
                    <SweetAlert
                        show={this.state.addGroupAlert}
                        title="Added to group."
                        text=""
                        onConfirm={() =>
                            this.setState({
                                addGroupAlert: false,
                                addGroupView: false,
                            })
                        }
                    />
                    <SweetAlert
                        show={this.state.modGroupAlert}
                        title="Comments have been modified."
                        text=""
                        onConfirm={() =>
                            this.setState({ modGroupAlert: false })
                        }
                    />

                    {this.state.addGroupView && (
                        <AddGroupView
                            setAddGroupView={() =>
                                this.setState({
                                    addGroupView: false,
                                    groupViewState: '',
                                    addGroupAlert: true,
                                })
                            }
                            setAddGroup={() =>
                                this.setState({ addGroupView: false })
                            }
                            getCookie={(name) => this.getCookie(name)}
                            groupList={this.state.groupList}
                        />
                    )}

                    <div className="docCon">
                        <div id="articles">{this.infoHandle()}</div>
                    </div>
                </div>
                {this.state.bookLoading && <Loading />}
                {/* <div className={this.state.isLoaded === true ? 'commentWrap active' : 'commentWrap'}>
					<select onChange={(e) => this.selectGrouup(e)} defaultValue="1" value={this.state.selectGroup}>
						<option value="1" disabled={true}>
							select group
						</option>
						{option}
					</select>
					<input
						placeholder="You can comment and save (optional)"
						value={this.state.comment}
						onChange={(e) => this.setState({ comment: e.target.value })}
					/>
					<button onClick={() => this.addBookmark()}>
						<img src={bookmark_white} />
					</button>
				</div> */}
            </article>
        );
	}
}



// WEBPACK FOOTER //
// ./src/components/ResultDetail.js